import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { Input } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaCurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput";
import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import { Monedas } from '../../Monedas/Monedas/constants.js'
import { formatCurrency } from '../../../functions/functions';
import { getMonedas } from "../../../api/apicalls.js";


class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            fecha: moment(),
            loteo: null,
            loteo_id: null,
            lote_id: null,
            obra_id: null,
            rubro_id: null,
            proveedor_id: null,
            monedas: [], // Todas las Monedas de la api
            moneda: null, // Moneda para el Input (object)
            monto: '0',
            tipoComprobante_id: null,
            nroComprobante: "",
            descripcion: "",
            caja_id: null,
            vendedor_id: null,
            concepto: '',
            postVariables: ['loteo_id', 'lote_id', 'vendedor_id', 'obra_id', 'rubro_id', 'proveedor_id', 'tipoComprobante_id', 'monto', 'nroComprobante', 'descripcion', 'caja_id', 'concepto'],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }

    async componentDidMount() {
        const monedas = await getMonedas();
        const monedaPesos = monedas
            ? monedas.find(moneda => moneda.id === Monedas.PESOS)
            : null;

        this.setState({ 
            monedas,
            moneda: monedaPesos,
        });
    }

    findMoneda = (monedaId) => {
        const { monedas } = this.state

        const moneda = monedas
            ? monedas.find(moneda => moneda.id === monedaId)
            : null;

        return moneda
    }

    getMonedaSimbolo = () => {
        const { moneda } = this.state
        return moneda ? moneda.simbolo : ""
    }

    resetForm() {
        const monedaPesos = this.findMoneda(Monedas.PESOS);

        this.setState({
            id: null,
            fecha: moment(),
            loteo: null,
            loteo_id: null,
            lote_id: null,
            obra_id: null,
            rubro_id: null,
            proveedor_id: null,
            moneda: monedaPesos,
            monto: '0',
            tipoComprobante_id: null,
            nroComprobante: "",
            descripcion: "",
            caja_id: null,
            vendedor_id: null,
            concepto: '',
            errors: [],
        });
    }

    getData() {
        const {
            postVariables,
            obra_id,
            obra,
            fecha,
            moneda,
        } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        const monedaId = moneda ? moneda.id : null;

        if (obra_id && obra) {
            data.obra_id = obra.id;
            data.proveedor_id = obra.proveedor.id;
        }
        data.moneda = monedaId; 
        data.fecha = fecha ? fecha.format('YYYY-MM-DDThh:mm') : null;
        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                id: data.id,
                fecha: moment(data.fecha),
                loteo_id: data.loteo.id,
                lote_id: data.lote ? data.lote.id : null,
                obra_id: data.obra ? data.obra.id : null,
                obra: data.obra,
                rubro_id: data.rubro.id,
                proveedor_id: data.proveedor.id,
                moneda: data.moneda,
                monto: data.monto,
                tipoComprobante_id: data.tipoComprobante ? data.tipoComprobante.id : null,
                nroComprobante: data.nroComprobante,
                descripcion: data.descripcion,
                vendedor_id: data.vendedor ? data.vendedor.id : null,
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nuevo Gasto",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "El Gasto ha sido creado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Gasto",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "El Gasto ha sido editado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Gasto",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Gasto",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "El Gasto ha sido eliminado con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    onValidation(){
        const { action } = this.props;
        const { caja_id } = this.state;
        let error = {};
        let validate = true;

        if(action=='CREATE'){
            if (caja_id==null){
                error.caja_id = [{code: "required", detail: "Selecciones una cuenta"}];
                validate = false;
            }
        }

        this.setState({
            errors: error,
        })
        return validate;
    }

    onLoteoChange = (loteo) => {
        // Se setean tanto el loteo como su moneda preferida.
        // (Nota) La moneda tiene que poder cambiarse, la del loteo es solo
        // un default.
        const loteoId = loteo ? loteo.id : null;
        const monedaPreferida = loteo && loteo.moneda_preferida
            ? loteo.moneda_preferida
            : this.findMoneda(Monedas.PESOS);
        this.onChangeField('loteo', loteo)
        this.onChangeField('loteo_id', loteoId)
        this.onChangeField('lote_id', null)
        this.onChangeField('obra', null)
        this.onChangeField('obra_id', null)
        this.onChangeField('moneda', monedaPreferida)
    }

    /*
    * Por ahora se paga en la misma moneda que la obra, asi hay consistencia
    * con la obra y los gastos.
    *
    * Si no se usa obra entonces se cambia a la preferencia del loteo
    */
    onObraChange = (obra) => {
        const { loteo } = this.state
        const obraId = obra ? obra.id : null;
        const obraObj = obra ? obra : null;
        const rubroId = obra && obra.proveedor.rubros.length ? obra.proveedor.rubros[0].id : null;
        const monedaObra = obra ? obra.moneda : null;
        const loteoMoneda = loteo ? loteo.moneda_preferida : null;
        const monedaPesos = this.findMoneda(Monedas.PESOS);

        this.onChangeField('obra_id', obraId)
        this.onChangeField('obra', obraObj)
        this.onChangeField('rubro_id', rubroId)
        this.onChangeField('moneda', monedaObra || loteoMoneda || monedaPesos)
    }

    onMonedaChange = (moneda) => {
        this.onChangeField('moneda', moneda)
    }

    render() {
        const { 
            caja_id,
            obra,
            moneda,
        } = this.state;
        let vars = this.modalVars();
        const { action } = this.props;
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];
        const isCreateWithObra = action === 'CREATE' && this.state.obra_id;
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.obras.gastos : null)}
                submitUrl={(vars.submitType ? api.obras.gastos : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                onValidation={() => this.onValidation()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
                className="ui-paradigma-modal ui-paradigma-modal-wide"
            >

                <div className="ui-section-grid">
                    <section className="ui-modal-section">
                        <p className="ui-section-label">Operación</p>
                        <div className="ui-form-grid">
                            <ParadigmaLabeledInput
                                label="Fecha"
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                error={() => this.getError('fecha')}
                                inputComponent={
                                    <ParadigmaDatePicker
                                        disabled={vars.disabled}
                                        value={this.state.fecha}
                                        onChange={data => this.onChangeField('fecha', data)}
                                    />
                                }
                            />

                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Loteo"}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        clearable={false}
                                        disabled={vars.disabled}
                                        url={api.loteos.loteos_select}
                                        parameters={{
                                            paginationEnabled:false,
                                            sort:['nombre']
                                        }}
                                        value={this.state.loteo_id}
                                        onChange={this.onLoteoChange}
                                    />
                                }
                                error={() => this.getError('loteo_id')}
                            />

                            <div className="ui-span-2">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Lote"}
                                    error={() => this.getError('lote_id')}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            clearable={true}
                                            optionRenderer={opts => `${opts.manzana} - ${opts.numero}`}
                                            url={this.state.loteo_id ? api.loteos.lotesSelect : ''}
                                            parameters={{
                                                id:this.state.loteo_id,
                                                paginationEnabled:false,
                                                sort:['manzana'],
                                            }}
                                            valueRenderer={opts => `Manzana: ${opts.manzana} - Número: ${opts.numero}`}
                                            disabled={vars.disabled}
                                            value={this.state.lote_id}
                                            onChange={data => this.onChangeField('lote_id', (data ? data.id : null))}
                                        />
                                    }
                                />
                            </div>

                            <div className="ui-span-2">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={fieldClassNames}
                                    label={"Obra"}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            clearable={true}
                                            disabled={!this.state.loteo_id ? true : vars.disabled}
                                            url={this.state.loteo_id ? api.obras.obras_select: ''}
                                            parameters={{
                                                paginationEnabled:false,
                                                sort:['titulo'],
                                                concat:this.state.loteo_id ? 'loteo=' + this.state.loteo_id + "&saldo[gt]=0":''
                                            }}
                                            displayField={'titulo'}
                                            value={this.state.obra_id}
                                            onChange={this.onObraChange}
                                        />
                                    }
                                    error={() => this.getError('obra_id')}
                                />
                            </div>
                        </div>
                    </section>

                    <section className="ui-modal-section">
                        <p className="ui-section-label">{isCreateWithObra ? "Datos de la obra" : "Clasificación"}</p>
                        <div className="ui-form-grid">
                            {isCreateWithObra ?
                                <Fragment>
                                    <ParadigmaLabeledInput
                                        label="Monto de la obra"
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        inputComponent={
                                            <ParadigmaCurrencyInput
                                                disabled={true}
                                                className="form-control monto w-100"
                                                symbol={obra ? obra.moneda.simbolo : ""}
                                                value={formatCurrency(obra ? obra.monto : 0)}
                                                onChange={data => this.onChangeField('rerender', data)}
                                            />
                                        }
                                    />
                                    <ParadigmaLabeledInput
                                        label="Pagado"
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        inputComponent={
                                            <ParadigmaCurrencyInput
                                                disabled={true}
                                                className="form-control monto w-100"
                                                symbol={obra ? obra.moneda.simbolo : ""}
                                                value={formatCurrency(obra ? obra.pagado : 0)}
                                                onChange={data => this.onChangeField('rerender', data)}
                                            />
                                        }
                                    />
                                    <ParadigmaLabeledInput
                                        label="Saldo actual"
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        inputComponent={
                                            <ParadigmaCurrencyInput
                                                disabled={true}
                                                className="form-control monto w-100"
                                                symbol={obra ? obra.moneda.simbolo : ""}
                                                value={formatCurrency(obra ? obra.saldo : 0)}
                                                onChange={data => this.onChangeField('rerender', data)}
                                            />
                                        }
                                    />
                                    <ParadigmaLabeledInput
                                        label="Proveedor"
                                        disabled={true}
                                        md={[12, 12]}
                                        classNames={fieldClassNames}
                                        value={obra && obra.proveedor ? obra.proveedor.nombre : ""}
                                    />
                                    <div className="ui-span-2">
                                        <ParadigmaLabeledInput
                                            md={[12, 12]}
                                            classNames={fieldClassNames}
                                            label={"Rubro"}
                                            inputComponent={
                                                <ParadigmaAsyncSeeker
                                                    clearable={false}
                                                    disabled={vars.disabled}
                                                    url={api.configuracion.rubros}
                                                    parameters={{
                                                        paginationEnabled:false,
                                                        sort:['nombre'],
                                                        concat:obra && obra.proveedor ? "id[in]=" + obra.proveedor.rubros.map(x => x.id) : ""
                                                    }}
                                                    value={this.state.rubro_id}
                                                    onChange={(data) => this.onChangeField('rubro_id', (data ? data.id : null))}
                                                />
                                            }
                                            error={() => this.getError('rubro_id')}
                                        />
                                    </div>
                                </Fragment>
                                :
                                <Fragment>
                                    <div className="ui-span-2">
                                        <ParadigmaLabeledInput
                                            md={[12, 12]}
                                            classNames={fieldClassNames}
                                            label={"Rubro"}
                                            inputComponent={
                                                <ParadigmaAsyncSeeker
                                                    clearable={false}
                                                    disabled={vars.disabled}
                                                    url={api.configuracion.rubros}
                                                    parameters={{
                                                        paginationEnabled:false,
                                                        sort:['nombre'],
                                                    }}
                                                    value={this.state.rubro_id}
                                                    onChange={(data) => this.onChangeField('rubro_id', (data ? data.id : null))}
                                                />
                                            }
                                            error={() => this.getError('rubro_id')}
                                        />
                                    </div>

                                    <div className="ui-span-2">
                                        <ParadigmaLabeledInput
                                            md={[12, 12]}
                                            classNames={fieldClassNames}
                                            label={"Proveedor"}
                                            inputComponent={
                                                <ParadigmaAsyncSeeker
                                                    clearable={false}
                                                    disabled={vars.disabled}
                                                    url={api.proveedores.proveedores_select}
                                                    parameters={{
                                                        paginationEnabled:false,
                                                        sort:['nombre'],
                                                    }}
                                                    value={this.state.proveedor_id}
                                                    onChange={(data) => this.onChangeField('proveedor_id', (data ? data.id : null))}
                                                />
                                            }
                                            error={() => this.getError('proveedor_id')}
                                        />
                                    </div>
                                </Fragment>
                            }
                        </div>
                    </section>
                </div>

                <section className="ui-modal-section">
                    <p className="ui-section-label">Comprobante</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Comprobante"}
                            error={() => this.getError('nroComprobante')}
                            inputComponent={
                                <div className="ui-composite-field ui-composite-field-receipt">
                                    <ParadigmaAsyncSeeker
                                        clearable={false}
                                        disabled={vars.disabled}
                                        url={api.configuracion.tiposdecomprobante}
                                        parameters={{
                                            paginationEnabled:false,
                                        }}
                                        value={this.state.tipoComprobante_id}
                                        displayField="abreviatura"
                                        onChange={(data) => this.onChangeField('tipoComprobante_id', (data ? data.id : null))}
                                    />
                                    <Input
                                        disabled={vars.disabled}
                                        value={this.state.nroComprobante}
                                        onChange={e => {
                                            e.persist();
                                            const value = (e.target.value || '').toUpperCase();
                                            this.setState(
                                                prevState => ({
                                                    nroComprobante: (/^[-\s]?([0-9]{0,5}[-\s]?[0-9]{0,8})?$/.test(value) || value === '') ? value : prevState.nroComprobante
                                                })
                                            )
                                        }}
                                    />
                                </div>
                            }
                        />

                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Vendedor"}
                            error={() => this.getError('vendedor_id')}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    displayField="apellido_nombre"
                                    clearable={false}
                                    url={api.vendedores.usuarios}
                                    parameters={{
                                        paginationEnabled:false,
                                    }}
                                    disabled={vars.disabled}
                                    value={this.state.vendedor_id}
                                    onChange={data => this.onChangeField('vendedor_id', (data ? data.id : null))}
                                />
                            }
                        />
                    </div>
                </section>

                <section className="ui-modal-section">
                    <p className="ui-section-label">Detalle</p>
                    <div className="ui-form-grid">
                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                type={'textarea'}
                                rows={5}
                                label={"Descripción"}
                                value={this.state.descripcion}
                                onChange={(e) => this.onChangeField('descripcion', e.target.value)}
                                error={() => this.getError('descripcion')}
                            />
                        </div>

                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Concepto"}
                            disabled={vars.disabled}
                            error={() => this.getError('concepto')}
                            value={this.state.concepto}
                            onChange={(e) => this.setState({concepto: e.target.value})}
                        />

                        {action === 'CREATE' &&
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Caja"}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        clearable={false}
                                        disabled={vars.disabled}
                                        url={api.caja.caja}
                                        parameters={{
                                            sort:['nombre'],
                                            paginationEnabled:false,
                                        }}
                                        value={caja_id}
                                        onChange={(data) => this.onChangeField('caja_id', (data ? data.id : null))}
                                    />
                                }
                                error={() => this.getError('caja_id')}
                            />}
                    </div>
                </section>

                <section className="ui-modal-section">
                    <p className="ui-section-label">Importe</p>
                    <div className="ui-money-grid">
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Moneda"}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    clearable={false}
                                    disabled={obra != null}
                                    url={api.monedas.monedas}
                                    parameters={{
                                        paginationEnabled:false,
                                    }}
                                    value={moneda ? moneda.id : null}
                                    onChange={this.onMonedaChange}
                                />
                            }
                            error={() => this.getError('moneda')}
                        />

                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Monto"}
                            error={() => this.getError('monto')}
                            inputComponent={
                                <ParadigmaCurrencyInput
                                    disabled={vars.disabled || action === 'EDIT'}
                                    className="form-control monto w-100"
                                    symbol={this.getMonedaSimbolo()}
                                    value={formatCurrency(this.state.monto)}
                                    onChange={data => this.onChangeField('monto', data)}
                                />
                            }
                        />
                    </div>
                </section>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Obras/Gastos/Modal.js